import { useTheme } from '../theme/ThemeProvider';
import { cn } from './ui/cn';

interface BrandProps {
  size?: 'sm' | 'md' | 'lg';
  showWordmark?: boolean;
  flat?: boolean;
  className?: string;
}

const ICON_SIZE = {
  sm: 'size-9',
  md: 'size-12',
  lg: 'size-16',
};

export function Brand({ size = 'sm', showWordmark = true, flat: _flat, className }: BrandProps) {
  const { resolved } = useTheme();
  const icon = resolved === 'dark' ? '/faviconWhite.svg' : '/faviconBlack.svg';
  return (
    <div className={cn('inline-flex items-center gap-2.5', className)}>
      <img src={icon} alt="OTG" className={cn('shrink-0 object-contain', ICON_SIZE[size])} />
      {showWordmark && (
        <span
          className={cn(
            'inline-flex items-baseline gap-[0.08em] leading-none',
            size === 'sm' && 'text-[24px] sm:text-[29px]',
            size === 'md' && 'text-[26px] sm:text-[30px]',
            size === 'lg' && 'text-[36px] sm:text-[45px]',
          )}
        >
          <span className="font-sora font-extrabold tracking-tight text-ink">OTG</span>
          <span className="font-jetbrains font-normal text-ink-muted">tracker</span>
        </span>
      )}
    </div>
  );
}
